import { Button, ButtonProps } from "@/components/ui/button";
import { Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useRowSelectionCount } from "@/components/data-table/hooks/useRowSelectionCount";

interface EmailRecipientsRemoveUsersButtonProps {
  onRemove?: () => Promise<void>;
  isSubmitting: boolean;
  variant?: ButtonProps["variant"];
  isDisabled?: boolean;
}

export const EmailRecipientsRemoveUsersButton = ({
  onRemove,
  isSubmitting,
  variant = "outline",
  isDisabled = false,
}: EmailRecipientsRemoveUsersButtonProps) => {
  const { t } = useTranslation();
  const selectedCount = useRowSelectionCount();

  return (
    <Button
      data-testid="email-recipients-remove-users-button"
      onClick={onRemove}
      className="gap-2"
      variant={variant}
      size="sm"
      type="button"
      disabled={isDisabled || isSubmitting || selectedCount === 0 || !onRemove}
    >
      <Trash2 className="w-5 h-5 mr-1" />
      {t("emailRecipients.removeUsers.button")}
      {selectedCount > 0 && ` (${selectedCount})`}
    </Button>
  );
};
